import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { i18n } from './modules/localization';

import { Toast, toastOptions } from './plugins/toast';

import './custom.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'animate.css';

createApp(App)
  .use(router)
  .use(Toast, toastOptions)
  .use(i18n)
  .mount('#app');
